  
    import CardRh from   "@/components/cards/ManzaCard.vue" 
    import { Options , Vue } from "vue-class-component";   
    import {  Prop  , Watch } from 'vue-property-decorator';   

    
    import { namespace } from 'vuex-class'; 
    const authStore = namespace('auth'); 


    @Options({
        name: "AulaPdf",
        components: {  CardRh  },   
    }) 
    export default class AulaPdf extends Vue { 
         
        @Prop( ) readonly dataAulaMin!: any  
        @Prop( ) readonly dataAulaMax!: any   
        @Prop( ) readonly service!: any   

        @authStore.Getter
		public token!: any
        
        public identificador = 1 ;   
        public url: any = "";
        public modal: any = "modal_pdf_relatorio_pagamento";
        public height_w: any =  window.innerHeight;
        public height_s: any =  screen.height;

        @Watch('matricula')
		dadosAtualizado(newVal: string) { 
            this.identificador++; 
		} 
  
        public gerarBoletim(){
            this.url =   null;  
            setTimeout(() => {
                this.url = this.service.getApiUrl() + `/Relatorio/Pagamento/Pdf?dataAulaMin=${this.dataAulaMin}&dataAulaMax=${this.dataAulaMax}&token=${this.token}`;
                this.identificador++;
            }, 2 ); 
        }
    } 
